/* Brunelia Riviera : comportements communs (aucune dépendance).
   API exposée : window.RV.toast(), RV.sel (sélection), RV.cart (panier), RV.share(), RV.openOverlay(), RV.closeOverlays(), RV.money().
   Événements : « rv:selection-change » (detail: liste), « rv:cart-change » (detail: panier), « rv:overlay-open » (detail: id). */
(function () {
  "use strict";
  var RV = window.RV = window.RV || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;"); };
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  var touch = window.matchMedia && window.matchMedia("(hover:none)").matches;
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  RV.$ = $; RV.$$ = $$; RV.esc = esc; RV.store = store; RV.touch = touch;

  /* ---------- Money: cents to the current currency format (« 14,95 € » in euros) ----------
     RV.moneySample is Shopify's own rendering of 1234567.89 in the current currency (layout). */
  /* Convention néerlandaise : symbole avant le montant (« € 19,95 ») ; le réglage de
     formatage monétaire de la boutique est unique pour toute la boutique (convention française) et
     ne varie pas par marché, même correctif que theme/snippets/rv-eur-nl.liquid côté serveur. */
  var legacyEur = function (v) {
    var s = v.toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return RV.lang === "nl" ? "€ " + s : s + " €";
  };
  var moneyParts = (function () {
    var s = RV.moneySample, m = s && String(s).match(/^(\D*?)1(\D?)234\D?56([78])(?:(\D)89)?(\D*)$/);
    return m ? { pre: m[1], th: m[2], dec: m[4] || "", suf: m[5] } : null;
  })();
  /* « $ » alone is ambiguous outside the US (Shopify formats CAD, AUD, NZD... as « $30.00 »): CA$, A$, NZ$, and US$
     when a non-US visitor pays in US dollars (20/10/2026). */
  var dollar = { CAD: "CA$", AUD: "A$", NZD: "NZ$", SGD: "S$", HKD: "HK$", MXN: "MX$", USD: RV.country === "US" ? "$" : "US$" }[RV.currency];
  if (moneyParts && dollar && moneyParts.pre.trim() === "$") moneyParts.pre = moneyParts.pre.replace("$", dollar);
  var isEur = !RV.currency || (RV.currency === "EUR" && (!moneyParts || /\s€$/.test(moneyParts.suf)));
  RV.money = function (cents) {
    var v = (Number(cents) || 0) / 100;
    if (isEur) return legacyEur(v);
    if (moneyParts) {
      var p = moneyParts, neg = v < 0, a = Math.abs(v);
      var str = p.dec ? a.toFixed(2) : String(Math.round(a)), parts = str.split(".");
      return (neg ? "-" : "") + p.pre + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, p.th) + (p.dec ? p.dec + parts[1] : "") + p.suf;
    }
    try { return new Intl.NumberFormat(RV.lang || undefined, { style: "currency", currency: RV.currency }).format(v); } catch (e) { return v.toFixed(2) + " " + RV.currency; }
  };
  /* same without zero decimals (« 59 € », « $79 ») */
  RV.moneyShort = function (cents) {
    var s = RV.money(cents);
    if (isEur) return s.replace(",00", "");
    return moneyParts && moneyParts.dec ? s.replace(moneyParts.dec + "00", "") : s;
  };
  /* « 3 affiches » / « 3 posters »: forms in locales (plural_js.<word>_one / _other), French rule n > 1, other languages n != 1 */
  RV.plural = function (n, w) {
    var many = RV.lang && RV.lang !== "fr" ? n !== 1 : n > 1;
    var s = RV.i18n && RV.i18n["plural_js." + w + (many ? "_other" : "_one")];
    return s != null ? s.replace(/\{\{\s*count\s*\}\}/g, n) : n + " " + w + (many ? "s" : "");
  };
  function emit(name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail })); }

  /* ---------- Toasts ---------- */
  RV.toast = function (msg, img, href, lbl) {
    var box = $("#rv-toasts"); if (!box) return;
    var t = document.createElement("div"); t.className = "toast"; t.setAttribute("role", "status");
    t.innerHTML = (img ? '<img src="' + esc(img) + '" alt="">' : "") + "<span>" + esc(msg) + "</span>" + (href ? '<a href="' + esc(href) + '">' + esc(lbl || RV.t("core_js.see")) + "</a>" : "");
    box.appendChild(t); setTimeout(function () { t.remove(); }, 3600);
  };

  /* ---------- Fenêtres (recherche, partage, panier, tiroir, QR, lettre) ---------- */
  /* technique-site 22/10: the Tab trap and the focus net also cover every other visible modal dialog (role=dialog aria-modal=true:
     collection Filter and Sort windows, product zoom, quick-add sheet, wall photos...), not only the RV overlays */
  function openDlg() {
    return $("[data-rv-overlay]:not([hidden]), [data-rv-drawer]:not([hidden])") || $$('[role="dialog"][aria-modal="true"]').filter(function (d) {
      return !d.hidden && !d.closest("[hidden]") && d.getClientRects().length > 0 && getComputedStyle(d).visibility !== "hidden";
    })[0] || null;
  }
  var lastFocus = null;
  RV.openOverlay = function (id) {
    var el = document.getElementById(id); if (!el) return;
    RV.closeOverlays(true);
    lastFocus = document.activeElement;
    el.hidden = false; document.documentElement.style.overflow = "hidden";
    var f = el.querySelector("[autofocus], input:not([type=hidden]), button, a[href]"); if (f) f.focus({ preventScroll: true });
    if (id === "rv-drawer") { $$('[data-rv-open="drawer"]').forEach(function (b) { b.setAttribute("aria-expanded", "true"); }); }
    emit("rv:overlay-open", id);
  };
  RV.closeOverlays = function (keepFocus) {
    var any = false;
    $$("[data-rv-overlay], [data-rv-drawer]").forEach(function (o) { if (!o.hidden) { o.hidden = true; any = true; } });
    $$('[data-rv-open="drawer"]').forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
    document.documentElement.style.overflow = "";
    /* ne pas rendre le focus à la barre de recherche de l'en-tête : son focus rouvre la recherche (fenêtre impossible à fermer, Romain 07/10) */
    if (any && !keepFocus && lastFocus && lastFocus.focus) {
      if (lastFocus.closest && lastFocus.closest("[data-rv-hsearch]")) lastFocus.blur();
      else lastFocus.focus({ preventScroll: true });
    }
  };
  /* barre de recherche de l'en-tête : un vrai champ (marche sans script) ; au focus, ouvre la recherche instantanée */
  document.addEventListener("focusin", function (e) {
    var f = e.target.closest && e.target.closest("[data-rv-hsearch]"); if (!f || e.target.tagName !== "INPUT") return;
    var v = e.target.value || ""; RV.openOverlay("rv-search");
    var i = $("#rv-search-in"); if (i) { if (v) { i.value = v; i.dispatchEvent(new Event("input", { bubbles: true })); } i.focus(); }
  });
  /* clic sur le panier fait avant le chargement de ce script (garde du layout) : ouvrir le tiroir maintenant */
  if (window.__rvPendingCart) { window.__rvPendingCart = 0; setTimeout(function () { RV.openOverlay("rv-cart"); }, 0); }
  window.addEventListener("click", function (e) {
    var o = e.target.closest && e.target.closest("[data-rv-open]");
    if (o && o.getAttribute("data-rv-open") !== "cart") e.stopImmediatePropagation();
    if (o) {
      var w = o.getAttribute("data-rv-open");
      if (w === "search") { e.preventDefault(); RV.openOverlay("rv-search"); var i = $("#rv-search-in"); if (i) { i.focus(); } return; }
      if (w === "cart") { if (location.pathname === RV.cartUrl) return; e.preventDefault(); RV.openOverlay("rv-cart"); return; }
      if (w === "drawer") { e.preventDefault(); RV.openOverlay("rv-drawer"); return; }
      if (w === "qr") { e.preventDefault(); RV.openQR(o.getAttribute("data-url") || location.href); return; }
    }
    if (e.target.closest("[data-rv-close]")) { e.preventDefault(); RV.closeOverlays(); return; }
    if (e.target.matches && (e.target.matches("[data-rv-overlay]") || e.target.matches("[data-rv-drawer]"))) { RV.closeOverlays(); }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { RV.closeOverlays(); closeMega(); return; }
    if (e.key !== "Tab") return;
    var open = openDlg(); if (!open) return;
    /* technique-site 22/10: visible = has a box (offsetParent is null for position:fixed buttons, e.g. the zoom close button) */
    var items = $$('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])', open).filter(function (x) { return !x.disabled && x.getClientRects().length > 0 && getComputedStyle(x).visibility !== "hidden"; });
    if (!items.length) return;
    /* piège actif à chaque Tab (pas seulement aux bords) : un simple « laisser filer sauf aux bords »
       se fait détourner par le bandeau de consentement cookies de Shopify, qui apparaît 1 à 3 s après
       le chargement de la page (avant toute interaction) et s'intercale dans l'ordre naturel du Tab,
       même quand le focus est déjà dans la fenêtre (mesuré : RV ne doit dépendre d'aucun autre script). */
    e.preventDefault();
    var i = items.indexOf(document.activeElement);
    var n = e.shiftKey ? (i <= 0 ? items.length - 1 : i - 1) : (i === -1 || i === items.length - 1 ? 0 : i + 1);
    items[n].focus();
  });
  /* le bandeau de consentement cookies de Shopify s'auto-focus parfois lui-même
     via son propre minuteur, indépendamment de toute touche Tab (mesuré : le
     vol survient entre deux évènements clavier, le seul piège sur Tab ne le voit
     pas). Ce deuxième filet réagit à toute prise de focus, quelle qu'en soit la cause. */
  document.addEventListener("focusin", function (e) {
    var open = openDlg(); if (!open) return;
    if (open.contains(e.target)) return;
    var items = $$('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])', open).filter(function (x) { return !x.disabled && x.getClientRects().length > 0 && getComputedStyle(x).visibility !== "hidden"; });
    if (items.length) items[0].focus();
  });

  /* ---------- Méga-menu ---------- */
  var mega = $("#rv-mega");
  function closeMega() {
    if (!mega) return;
    $$("[data-rv-mega]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
    mega.hidden = true;
  }
  /* technique-site 22/10: keyboard path through the mega-menu (a disclosure, not a modal): Tab on the open button goes into its
     pane, Shift+Tab on the first link goes back to the button, Tab past the last link closes it and goes on to the next header
     item, Escape closes it and gives the focus back to the button (capture phase: runs before the Escape handler above). */
  document.addEventListener("keydown", function (e) {
    if (!mega || mega.hidden || (e.key !== "Tab" && e.key !== "Escape")) return;
    var btn = $('[data-rv-mega][aria-expanded="true"]'); if (!btn) return;
    if (e.key === "Escape") { setTimeout(function () { btn.focus(); }, 0); return; }
    var pane = mega.querySelector('[data-for="' + btn.getAttribute("data-pane") + '"]') || mega;
    var fs = $$('a[href], button, input, [tabindex]:not([tabindex="-1"])', pane).filter(function (x) { return !x.disabled && x.offsetParent !== null; });
    if (!fs.length) return;
    var a = document.activeElement;
    if (a === btn && !e.shiftKey) { e.preventDefault(); fs[0].focus(); return; }
    if (a === fs[0] && e.shiftKey) { e.preventDefault(); btn.focus(); return; }
    if (a === fs[fs.length - 1] && !e.shiftKey) {
      var hs = $$('a[href], button, input:not([type=hidden])', btn.closest("header") || document.body).filter(function (x) { return x.offsetParent !== null && !mega.contains(x); });
      var nx = hs[hs.indexOf(btn) + 1]; e.preventDefault(); closeMega(); (nx || btn).focus();
    }
  }, true);
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-rv-mega]");
    if (b && mega) { var open = b.getAttribute("aria-expanded") === "true"; b.setAttribute("aria-expanded", String(!open)); mega.hidden = open; return; }
    if (mega && !mega.hidden && !e.target.closest("#rv-mega")) closeMega();
  });

  /* ---------- Onglets du tiroir (et tout [role=tablist] avec data-rv-tab) ---------- */
  function selectTab(t) {
    var list = t.closest("[role=tablist]"); if (!list) return;
    $$("[data-rv-tab]", list).forEach(function (x) {
      var on = x === t; x.setAttribute("aria-selected", String(on)); x.tabIndex = on ? 0 : -1;
      var p = document.getElementById(x.getAttribute("aria-controls")); if (p) p.hidden = !on;
    });
  }
  document.addEventListener("click", function (e) { var t = e.target.closest("[data-rv-tab]"); if (t) selectTab(t); });
  document.addEventListener("keydown", function (e) {
    var t = e.target.closest && e.target.closest("[data-rv-tab]"); if (!t || (e.key !== "ArrowRight" && e.key !== "ArrowLeft")) return;
    var tabs = $$("[data-rv-tab]", t.closest("[role=tablist]")), i = tabs.indexOf(t);
    var n = tabs[(i + (e.key === "ArrowRight" ? 1 : tabs.length - 1)) % tabs.length]; selectTab(n); n.focus(); e.preventDefault();
  });
  RV.selectTab = selectTab;

  /* ---------- Ma sélection (navigateur, sans compte, 50 affiches au plus) ----------
     Élément : { h: handle, f: format ("A3" ou ""), t: titre, i: image, p: prix en centimes, d: date d'ajout } */
  var SKEY = "rv-selection", MAX = 50;
  var sel = store.get(SKEY, []); if (!Array.isArray(sel)) sel = [];
  RV.sel = {
    list: function () { return sel.slice(); },
    has: function (h) { return sel.some(function (x) { return x.h === h; }); },
    add: function (it) {
      if (RV.sel.has(it.h)) return false;
      if (sel.length >= MAX) { RV.toast(RV.t("core_js.sel_full", { max: MAX })); return false; }
      it.d = Date.now(); sel.push(it); save(); return true;
    },
    remove: function (h) { sel = sel.filter(function (x) { return x.h !== h; }); save(); },
    setFormat: function (h, f) { sel.forEach(function (x) { if (x.h === h) x.f = f; }); save(); },
    clear: function () { sel = []; save(); },
    merge: function (items) { var n = 0; items.forEach(function (it) { if (!RV.sel.has(it.h) && sel.length < MAX) { it.d = Date.now(); sel.push(it); n++; } }); save(); return n; },
    shareUrl: function (list) {
      list = list || sel;
      return RV.shopUrl + RV.selectionUrl + "?s=" + list.map(function (x) { return encodeURIComponent(x.h) + (x.f ? "." + encodeURIComponent(x.f) : ""); }).join(",");
    },
    parse: function (q) {
      if (!q) return [];
      return q.split(",").filter(Boolean).map(function (p) { var a = p.split("."); return { h: decodeURIComponent(a[0]), f: a[1] ? decodeURIComponent(a[1]) : "" }; });
    }
  };
  function save() { store.set(SKEY, sel); refreshSel(); emit("rv:selection-change", sel.slice()); }
  function refreshSel() {
    $$("[data-rv-selcount]").forEach(function (b) { b.textContent = sel.length; b.classList.toggle("zero", !sel.length); });
    $$("[data-rv-heart]").forEach(function (b) {
      var on = RV.sel.has(b.getAttribute("data-rv-heart")); b.setAttribute("aria-pressed", String(on));
      var lab = b.querySelector("[data-rv-heart-label]"); if (lab) lab.textContent = on ? RV.t("core_js.in_sel") : RV.t("core_js.add_sel");
    });
  }
  RV.refreshSel = refreshSel;
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-rv-heart]"); if (!b) return;
    e.preventDefault();
    var h = b.getAttribute("data-rv-heart");
    if (RV.sel.has(h)) { RV.sel.remove(h); RV.toast(RV.t("core_js.removed_sel"), b.getAttribute("data-rv-img")); return; }
    var fmt = b.getAttribute("data-rv-format") || "";
    var ok = RV.sel.add({ h: h, f: fmt, t: b.getAttribute("data-rv-title") || "", i: b.getAttribute("data-rv-img") || "", p: Number(b.getAttribute("data-rv-price")) || 0 });
    if (ok) RV.toast(RV.t("core_js.kept_sel") + (fmt ? " · " + fmt : ""), b.getAttribute("data-rv-img"), RV.selectionUrl, RV.t("core_js.see"));
  });
  refreshSel();

  /* Rappel « Vous aviez gardé N affiches » : visiteur qui revient (dernier ajout il y a plus de 30 min),
     une fois par visite, sur l'accueil et les collections, fermable pour 3 jours. */
  function showRappel() {
    var r = $("[data-rv-rappel]"); if (!r || !sel.length) return;
    var last = Math.max.apply(null, sel.map(function (x) { return x.d || 0; }));
    if (Date.now() - last < 30 * 60 * 1000) return;
    if (Date.now() < store.get("rv-rappel-off", 0)) return;
    try { if (sessionStorage.getItem("rv-rappel-vu")) return; sessionStorage.setItem("rv-rappel-vu", "1"); } catch (e) {}
    r.innerHTML = '<button class="x" type="button" data-rv-rappel-x aria-label="' + RV.t("core_js.close") + '">×</button><span class="script">' + RV.t("core_js.rappel_kept", { items: RV.plural(sel.length, "affiche") }) + "</span><p>" + RV.t("core_js.rappel_wait") + "</p>" +
      '<div class="thumbs">' + sel.slice(0, 4).map(function (x) { return x.i ? '<img src="' + esc(x.i) + '" alt="">' : ""; }).join("") + "</div>" +
      '<a class="btn btn-sm btn-main" href="' + esc(RV.selectionUrl) + '">' + RV.t("core_js.rappel_cta") + "</a>";
    r.hidden = false;
    setTimeout(function () { r.hidden = true; }, 9000);
  }
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-rv-rappel-x]")) { var r = $("[data-rv-rappel]"); if (r) r.hidden = true; store.set("rv-rappel-off", Date.now() + 3 * 864e5); }
  });
  var bt = document.body.className;
  if (/tpl-index|tpl-collection/.test(bt)) setTimeout(showRappel, 1400);

  /* ---------- Panier (API AJAX Shopify + rendu de section) ---------- */
  function cartSection(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, "text/html");
    var fresh = doc.querySelector("#rv-cart"), cur = $("#rv-cart");
    if (fresh && cur) {
      var wasOpen = !cur.hidden;
      cur.innerHTML = fresh.innerHTML;
      cur.hidden = !wasOpen;
      var n = fresh.getAttribute("data-rv-cart-count");
      cur.setAttribute("data-rv-cart-count", n);
      $$("[data-rv-cartcount]").forEach(function (b) { b.textContent = n; b.classList.toggle("zero", n === "0"); });
    }
  }
  RV.cart = {
    add: function (items, opts) {
      opts = opts || {};
      return fetch(RV.cartAddUrl + ".js", {
        method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: items, sections: "rv-cart-drawer", sections_url: location.pathname })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (j) {
          cartSection(j.sections && j.sections["rv-cart-drawer"]);
          emit("rv:cart-change", j);
          if (opts.open !== false) RV.openOverlay("rv-cart");
          return j;
        })
        .catch(function (err) {
          RV.toast((err && (err.description || err.message)) || RV.t("core_js.atc_error"));
          throw err;
        });
    },
    change: function (key, qty) {
      return fetch(RV.cartChangeUrl + ".js", {
        method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: key, quantity: qty, sections: "rv-cart-drawer", sections_url: location.pathname })
      }).then(function (r) { return r.json(); }).then(function (j) { cartSection(j.sections && j.sections["rv-cart-drawer"]); emit("rv:cart-change", j); return j; });
    }
  };
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-rv-qty]"); if (!b) return;
    e.preventDefault(); b.disabled = true;
    RV.cart.change(b.getAttribute("data-rv-qty"), Number(b.getAttribute("data-q")));
  });
  /* audit CRO 23/10 (approf-cro.md §5.2) : code promo centralisé ici (document entier) au lieu de rv-lot2.js
     (chargé seulement sur /cart, /packs et la fiche produit) pour marcher aussi dans le tiroir panier, ouvert sur toute page. */
  var applyPromo = function (input) {
    var code = (input.value || "").trim(); if (!code) { input.focus(); return; }
    location.href = "/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(location.pathname);
  };
  document.addEventListener("click", function (e) {
    var go = e.target.closest("[data-rv-promo-go]"); if (!go) return;
    var box = go.closest(".rv-promo"), input = box && box.querySelector("[data-rv-promo]");
    if (input) applyPromo(input);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Enter") return;
    var input = e.target.closest && e.target.closest("[data-rv-promo]"); if (!input) return;
    e.preventDefault(); applyPromo(input);
  });
  /* Tout formulaire produit marqué data-rv-atc part en AJAX (affiches et packs). Champs : id, quantity, properties[...]. */
  /* phase de capture sur window + arrêt de la propagation : aucun autre script (ex. standard-actions.js de Shopify)
     ne doit renvoyer le formulaire en plus de l'ajout AJAX (sinon 2 exemplaires et départ vers /cart) */
  window.addEventListener("submit", function (e) {
    var f = e.target.closest && e.target.closest("form[data-rv-atc]"); if (!f) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (f.__rvBusy) return; f.__rvBusy = true; setTimeout(function () { f.__rvBusy = false; }, 1500);
    var fd = new FormData(f), item = { id: Number(fd.get("id")), quantity: Number(fd.get("quantity") || 1) }, props = {};
    fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; });
    if (Object.keys(props).length) item.properties = props;
    var btn = f.querySelector("[type=submit]"); if (btn) btn.disabled = true;
    RV.cart.add([item]).then(function () {
      var img = f.getAttribute("data-img"); RV.toast(RV.t("core_js.added_cart") + (f.getAttribute("data-fmt") ? " · " + f.getAttribute("data-fmt") : ""), img);
      /* GA4 (audit legal-tracking 23/10) : aucun evenement e-commerce ne partait vers Google Tag Manager a l'ajout panier.
         Le prix vient du data-price (centimes) du champ id choisi, le nom du data-title du plus proche ancetre (fiche produit). */
      var idEl = f.querySelector('input[name="id"]:checked') || f.querySelector('input[name="id"]');
      var priceC = idEl ? Number(idEl.getAttribute("data-price")) || 0 : 0, titleEl = f.closest("[data-title]");
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          currency: RV.currency,
          value: (priceC / 100) * item.quantity,
          items: [{ item_id: String(item.id), item_name: titleEl ? titleEl.getAttribute("data-title") : document.title, item_variant: f.getAttribute("data-fmt") || "", price: priceC / 100, quantity: item.quantity }]
        }
      });
      /* OS-3 : mesure sans cookie d'un ajout panier confirmé, uniquement si le clic d'origine est humain
         (isTrusted exclut le rejeu automatique du formulaire en attente, ligne ci-dessous) */
      if (e.isTrusted && RV.rechercheUrl && navigator.sendBeacon) {
        var mesure = new Blob([JSON.stringify({ type: "clic", action: "ajout_panier", page: location.pathname })], { type: "text/plain" });
        navigator.sendBeacon(RV.rechercheUrl, mesure);
      }
    }).catch(function () {}).then(function () { if (btn) btn.disabled = false; });
  }, true);
  /* un clic « Ajouter au panier » fait avant le chargement de ce script a été retenu par le garde du layout : on le rejoue */
  if (window.__rvPendingAtc) { var pf = window.__rvPendingAtc; window.__rvPendingAtc = null; pf.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true })); }

  /* ---------- Partage : la carte postale à envoyer ----------
     Bouton : [data-rv-share="produit|collection|article|pack|page|selection|mur"] data-title data-img data-url [data-mode="conjoint"] [data-message] */
  function shareHTML(o) {
    var conj = o.mode === "conjoint";
    var msg = o.message || (conj ? RV.t("core_js.msg_partner", { title: o.title }) : RV.t("core_js.msg_share", { title: o.title }));
    var nets = conj ?
      [["wa", "WhatsApp", "#25a35a", "i-wa"], ["ms", "Messenger", "#2d6cdf", "i-ms"], ["ig", "Instagram", "#c13584", "i-ig"], ["sms", "SMS", "var(--sea)", "i-send"], ["mail", RV.t("core_js.net_mail"), "var(--ink)", "i-mail"], ["copy", RV.t("core_js.net_copy"), "var(--ink-soft)", "i-link"], ["plus", RV.t("core_js.net_more"), "var(--coral-deep)", "i-plus"]] :
      [["wa", "WhatsApp", "#25a35a", "i-wa"], ["ms", "Messenger", "#2d6cdf", "i-ms"], ["ig", "Instagram", "#c13584", "i-ig"], ["sms", "SMS", "var(--sea)", "i-send"], ["mail", RV.t("core_js.net_mail"), "var(--ink)", "i-mail"], ["pin", "Pinterest", "#b7081b", "i-pin"], ["fb", "Facebook", "#1d4f91", "i-fb"], ["x", "X", "#111"], ["copy", RV.t("core_js.net_copy"), "var(--ink-soft)", "i-link"]];
    return '<button class="modal-x" type="button" data-rv-close aria-label="' + RV.t("core_js.close") + '"><svg width="18" height="18" aria-hidden="true"><use href="#i-close"/></svg></button>' +
      '<div class="modal-h"><span class="script">' + (conj ? RV.t("core_js.share_second") : RV.t("core_js.share_card")) + '</span><h2 id="rv-share-h">' + (conj ? RV.t("core_js.share_partner") : RV.t("core_js.share_h")) + "</h2></div>" +
      '<div class="modal-b" data-rv-sharebox data-type="' + esc(o.type) + '" data-title="' + esc(o.title) + '" data-img="' + esc(o.img) + '" data-url="' + esc(o.url) + '" data-mode="' + (conj ? "conjoint" : "") + '">' +
      '<div class="share-mode"><button class="chip" type="button" data-rv-smode="" aria-pressed="' + (!conj) + '">' + RV.t("core_js.share_everyone") + '</button><button class="chip" type="button" data-rv-smode="conjoint" aria-pressed="' + conj + '">' + RV.t("core_js.share_partner") + '</button></div>' +
      '<div class="sendcard"><div class="l">' + (o.img ? '<img src="' + esc(o.img) + '" alt="">' : "") + "<b>" + esc(o.title) + '</b></div><div class="r"><span class="stamp-mini" style="--behind:var(--paper)"><div>BRUNELIA</div></span><label for="rv-smsg">' + RV.t("core_js.share_word") + '</label><textarea id="rv-smsg" data-rv-smsg>' + esc(msg) + "</textarea></div></div>" +
      '<div class="share-grid">' + (touch && navigator.share ? '<button type="button" class="native" data-rv-net="native"><svg width="18" height="18" aria-hidden="true"><use href="#i-share"/></svg>' + RV.t("core_js.share_native") + '</button>' : "") +
      nets.map(function (n) { return '<button type="button" data-rv-net="' + n[0] + '"><i style="--c:' + n[2] + '">' + (n[3] ? '<svg width="13" height="13" aria-hidden="true"><use href="#' + n[3] + '"/></svg>' : n[1].charAt(0)) + "</i>" + n[1] + "</button>"; }).join("") + "</div>" +
      '<p class="share-note">' + RV.t("core_js.share_note", { what: o.type === "produit" ? RV.t("core_js.this_poster") : RV.t("core_js.this_page") }) + "</p></div>";
  }
  RV.share = function (o) {
    o.url = o.url || location.href;
    if (o.type === "selection" && !o.urlFixed) o.url = RV.sel.shareUrl();
    var card = $("#rv-share-card"); if (!card) return;
    card.innerHTML = shareHTML(o); RV.openOverlay("rv-share");
  };
  RV.copy = function (txt, msg) {
    var done = function () { RV.toast(msg || RV.t("core_js.link_copied")); };
    try { navigator.clipboard.writeText(txt).then(done, function () { RV.toast(RV.t("core_js.copy_this", { url: txt })); }); } catch (err) { RV.toast(RV.t("core_js.copy_this", { url: txt })); }
  };
  function openLink(href) { var a = document.createElement("a"); a.href = href; a.target = "_blank"; a.rel = "nofollow noopener"; document.body.appendChild(a); a.click(); a.remove(); }
  document.addEventListener("click", function (e) {
    var s = e.target.closest("[data-rv-share]");
    if (s) {
      e.preventDefault();
      var o = { type: s.getAttribute("data-rv-share"), title: s.getAttribute("data-title") || document.title, img: s.getAttribute("data-img") || "", url: s.getAttribute("data-url") || "", mode: s.getAttribute("data-mode") || "", message: s.getAttribute("data-message") || "" };
      if (o.url && o.type === "selection") o.urlFixed = true;
      if (touch && navigator.share && o.mode === "conjoint") {
        var txt = o.message || RV.t("core_js.msg_partner", { title: o.title });
        navigator.share({ title: o.title, text: txt, url: o.type === "selection" && !o.urlFixed ? RV.sel.shareUrl() : (o.url || location.href) }).catch(function () {});
        return;
      }
      RV.share(o); return;
    }
    var sm = e.target.closest("[data-rv-smode]");
    if (sm) {
      var bx = sm.closest("[data-rv-sharebox]");
      $("#rv-share-card").innerHTML = shareHTML({ type: bx.dataset.type, title: bx.dataset.title, img: bx.dataset.img, url: bx.dataset.url, mode: sm.getAttribute("data-rv-smode") });
      return;
    }
    var n = e.target.closest("[data-rv-net]");
    if (n) {
      var box = n.closest("[data-rv-sharebox]"), url = box.dataset.url || location.href, txt2 = $("[data-rv-smsg]", box).value, full = txt2 + " " + url, E = encodeURIComponent;
      switch (n.getAttribute("data-rv-net")) {
        case "native": case "plus":
          if (navigator.share) navigator.share({ title: box.dataset.title, text: txt2, url: url }).catch(function () {}); else RV.copy(full, RV.t("core_js.copied_all")); return;
        case "wa": openLink("https://wa.me/?text=" + E(full)); return;
        case "ms": if (touch) openLink("fb-messenger://share/?link=" + E(url)); else RV.copy(full, RV.t("core_js.copied_ms")); return;
        case "ig": RV.copy(full, RV.t("core_js.copied_ig")); return;
        case "sms": location.href = "sms:?&body=" + E(full); return;
        case "mail": location.href = "mailto:?subject=" + E(box.dataset.title) + "&body=" + E(full); return;
        case "pin": openLink("https://www.pinterest.com/pin/create/button/?url=" + E(url) + "&media=" + E(box.dataset.img) + "&description=" + E(box.dataset.title)); return;
        case "fb": openLink("https://www.facebook.com/sharer/sharer.php?u=" + E(url)); return;
        case "x": openLink("https://x.com/intent/post?text=" + E(txt2) + "&url=" + E(url)); return;
        case "copy": RV.copy(url); return;
      }
    }
    var c = e.target.closest("[data-rv-copy]");
    if (c) { e.preventDefault(); RV.copy(c.getAttribute("data-url") || RV.qrUrl || location.href); }
  });

  /* ---------- 4 boutons ronds de partage (snippet rv-sendto) : Partager, Envoyer à mon conjoint, E-mail, Copier le lien ----------
     [data-rv-sendto] data-type data-url data-title data-img data-msg [data-sel] ; boutons [data-rv-to="native|wa|mail|copy"].
     « Envoyer à mon conjoint » (WhatsApp) et E-mail sont de vrais liens, réécrits au clic (format choisi, sélection en cours).
     Partager : feuille de partage du téléphone ; sinon la fenêtre de partage (WhatsApp, Messenger, Pinterest, Facebook, X, copier). */
  function sendUrl(box) { return box.hasAttribute("data-sel") && RV.selShareUrl ? RV.selShareUrl() : (box.getAttribute("data-url") || location.href); }
  RV.sendRefresh = function (box) {
    if (!box) return;
    var url = sendUrl(box), msg = box.getAttribute("data-msg") || "", E = encodeURIComponent;
    var wa = $('[data-rv-to="wa"]', box), mail = $('[data-rv-to="mail"]', box);
    if (wa) wa.href = "https://wa.me/?text=" + E((msg ? msg + " " : "") + url);
    if (mail) mail.href = "mailto:?subject=" + E(box.getAttribute("data-title") || "") + "&body=" + E((msg ? msg + "\n\n" : "") + url);
  };
  document.addEventListener("click", function (e) {
    var to = e.target.closest("[data-rv-to]"); if (!to) return;
    var box = to.closest("[data-rv-sendto]"); if (!box) return;
    RV.sendRefresh(box);
    var k = to.getAttribute("data-rv-to"), url = sendUrl(box), title = box.getAttribute("data-title") || document.title;
    if (k === "native") {
      e.preventDefault();
      if (touch && navigator.share) navigator.share({ title: title, url: url }).catch(function () {});
      else RV.share({ type: box.getAttribute("data-type") || "page", title: title, img: box.getAttribute("data-img") || "", url: url, urlFixed: true });
    } else if (k === "copy") { e.preventDefault(); RV.copy(url, RV.t("core_js.link_copied")); }
  });

  /* ---------- QR code : « Continuer sur mon téléphone » ----------
     L'encodeur (assets/rv-qr.js, fournit window.RVQR.svg(texte)) est chargé à la demande, sans service tiers. */
  RV.openQR = function (url) {
    RV.qrUrl = url;
    var box = $("#rv-qr-code");
    function draw() { if (box && window.RVQR) box.innerHTML = window.RVQR.svg(url); RV.openOverlay("rv-qr"); }
    if (window.RVQR) return draw();
    var s = document.createElement("script"); s.src = RV.qrSrc || ""; s.onload = draw; s.onerror = function () { if (box) box.textContent = ""; RV.openOverlay("rv-qr"); };
    if (RV.qrSrc) document.head.appendChild(s); else draw();
  };

  /* ---------- Recherche instantanée (API predictive search de Shopify) + « Vous cherchiez … ? » ---------- */
  var COLL = [];
  try { COLL = JSON.parse(($("#rv-coll-index") || {}).textContent || "[]"); } catch (e) {}
  var norm = function (s) { return String(s).toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/['’]/g, " ").trim(); };
  function lev(a, b) { var m = [], i, j; for (i = 0; i <= b.length; i++) m[i] = [i]; for (j = 0; j <= a.length; j++) m[0][j] = j; for (i = 1; i <= b.length; i++) for (j = 1; j <= a.length; j++) m[i][j] = b[i - 1] === a[j - 1] ? m[i - 1][j - 1] : Math.min(m[i - 1][j - 1] + 1, m[i][j - 1] + 1, m[i - 1][j] + 1); return m[b.length][a.length]; }
  function hl(s, q) { if (!q) return esc(s); var i = norm(s).indexOf(q); return i < 0 ? esc(s) : esc(s.slice(0, i)) + "<mark>" + esc(s.slice(i, i + q.length)) + "</mark>" + esc(s.slice(i + q.length)); }
  var WALLS = ["var(--lemon-pale)", "var(--sea-pale)", "var(--coral-pale)", "var(--pine-pale)", "var(--sand-2)"];
  var searchIdle = null, searchTimer = null, searchCtl = null;
  function renderSearch(q, res) {
    var n = norm(q), did = null;
    var cols = COLL.filter(function (c) { return norm(c.t).indexOf(n) > -1; });
    var prods = (res && res.products) || [], arts = (res && res.articles) || [];
    if (!cols.length && n.length > 3) {
      var best = null, bd = 9; COLL.forEach(function (c) { var d = lev(n, norm(c.t)); if (d < bd) { bd = d; best = c; } });
      if (best && bd <= 2) { did = best; cols = [best]; }
    }
    var left = (did ? '<p class="didyou">' + RV.t("core_js.did_you", { link: '<a href="' + esc(did.u) + '">' + esc(did.t) + "</a>" }) + "</p>" : "") +
      "<h3>" + RV.t("core_js.h_collections") + "</h3><ul class=\"sov-list\">" + (cols.length ? cols.slice(0, 6).map(function (c) { return '<li><a href="' + esc(c.u) + '"><span>' + hl(c.t, did ? "" : n) + "</span><small>" + RV.plural(c.n, "affiche") + "</small></a></li>"; }).join("") : '<li style="color:var(--ink-soft);padding:6px 0">' + RV.t("core_js.no_collection") + "</li>") + "</ul>" +
      (arts.length ? "<h3>" + RV.t("core_js.h_magazine") + "</h3><ul class=\"sov-list sov-arts\">" + arts.slice(0, 3).map(function (a) { return '<li><a href="' + esc(a.url) + '"><span>' + hl(a.title, n) + "</span></a></li>"; }).join("") + "</ul>" : "");
    var right = "<h3>" + RV.t("core_js.h_posters") + "</h3>" + (prods.length ? '<div class="sov-prods">' + prods.slice(0, 6).map(function (p, i) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf("?") > -1 ? "&" : "?") + "width=200" : "";
      return '<a class="sov-p" href="' + esc(p.url) + '"><div class="wall" style="--w:' + WALLS[i % 5] + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : "") + "</div>" + hl(p.title, n) + '<br><small style="font-weight:400">' + RV.t("core_js.from_price", { price: esc(RV.money(Math.round(parseFloat(p.price_min || p.price || 0) * 100))) }) + "</small></a>";
    }).join("") + "</div>" : (did ? "" : '<div class="zero"><span class="script">' + RV.t("core_js.zero_title") + "</span><p>" + RV.t("core_js.zero_text") + "</p></div>")) +
      '<p class="sov-all"><a href="' + esc(RV.searchUrl) + "?q=" + encodeURIComponent(q) + '&type=product">' + RV.t("core_js.see_all", { q: esc(q) }) + "</a></p>";
    $("#rv-search-res").innerHTML = "<div>" + left + "</div><div>" + right + "</div>";
  }
  document.addEventListener("input", function (e) {
    if (e.target.id !== "rv-search-in") return;
    var q = e.target.value.trim(), box = $("#rv-search-res");
    if (searchIdle == null && box) searchIdle = box.innerHTML;
    clearTimeout(searchTimer);
    if (!q) { if (box && searchIdle != null) box.innerHTML = searchIdle; return; }
    searchTimer = setTimeout(function () {
      if (searchCtl) searchCtl.abort();
      searchCtl = window.AbortController ? new AbortController() : null;
      var url = (RV.predictiveUrl || "/search/suggest") + ".json?q=" + encodeURIComponent(q) + "&resources[type]=product,article&resources[limit]=6&resources[options][unavailable_products]=last";
      fetch(url, searchCtl ? { signal: searchCtl.signal } : {}).then(function (r) { return r.json(); })
        .then(function (j) { renderSearch(q, j.resources && j.resources.results); })
        .catch(function (err) { if (!err || err.name !== "AbortError") renderSearch(q, null); });
    }, 140);
  });
  document.addEventListener("click", function (e) {
    var q = e.target.closest("[data-rv-q]"); if (!q) return;
    e.preventDefault(); var i = $("#rv-search-in"); if (!i) return; i.value = q.getAttribute("data-rv-q"); i.dispatchEvent(new Event("input", { bubbles: true })); i.focus();
  });

  /* ---------- OS-5 : mesure des vraies recherches du site (texte final, sans donnée personnelle) ----------
     1,5 s sans frappe, 3 caractères minimum, une fois par texte ; silencieux si RV.rechercheUrl est vide
     ou si le chemin n'est pas encore ouvert côté serveur (sendBeacon ignore la réponse). */
  var logTimer = null, logged = "";
  document.addEventListener("input", function (e) {
    if (e.target.id !== "rv-search-in" || !RV.rechercheUrl || !navigator.sendBeacon) return;
    var q = e.target.value.trim();
    clearTimeout(logTimer);
    if (q.length < 3) return;
    logTimer = setTimeout(function () {
      if (q === logged) return;
      logged = q;
      var data = new Blob([JSON.stringify({ q: q, page: location.pathname })], { type: "text/plain" });
      navigator.sendBeacon(RV.rechercheUrl, data);
    }, 1500);
  });

  /* ---------- Lettre d'information : popup de bienvenue (Klaviyo, API client publique) ----------
     30 s on the page, or 60 % scrolled after 12 s, or exit intent on desktop. Never on cart / account pages,
     never for visitors coming from a Klaviyo mail or already subscribed (data-skip). Once shown or closed: 30 days off. */
  var nl = $("#rv-nl"), NLKEY = "rv-nl", DAY = 864e5;
  if (nl && /utm_source=klaviyo|_kx=/.test(location.search)) store.set(NLKEY, Date.now() + 30 * DAY);
  if (nl && !nl.hasAttribute("data-skip") && !/tpl-cart|tpl-customers|tpl-password|tpl-gift_card/.test(bt) && Date.now() > store.get(NLKEY, 0)) {
    var shown = false, t0 = Date.now();
    var show = function () {
      if (shown) return;
      if (document.querySelector("[data-rv-overlay]:not([hidden]), [data-rv-drawer]:not([hidden])")) { setTimeout(show, 15000); return; }
      shown = true; store.set(NLKEY, Date.now() + 30 * DAY); RV.openOverlay("rv-nl");
    };
    setTimeout(show, 30000);
    window.addEventListener("scroll", function onS() {
      var h = document.documentElement, p = (h.scrollTop + innerHeight) / Math.max(h.scrollHeight, 1);
      if (p > 0.6 && Date.now() - t0 > 12000) { window.removeEventListener("scroll", onS); show(); }
    }, { passive: true });
    if (!touch) document.addEventListener("mouseout", function (e) { if (!e.relatedTarget && e.clientY < 8 && Date.now() - t0 > 5000) show(); });
  }
  /* Newsletter signup endpoint (VPS, scripts/inscription/server.mjs): creates or updates the Shopify customer with email
     marketing consent and the tags. Resolves true only on {ok:true}. A hidden honeypot field "website" is added to every
     newsletter form; t = ms spent on the page (bots submit instantly). */
  var RV_NL_URL = "https://brunelia.srv887247.hstgr.cloud/inscription/v1/subscribe";
  document.querySelectorAll("form[data-rv-newsletter]").forEach(function (f) {
    if (f.querySelector("input[name=website]")) return;
    var h = document.createElement("input"); h.type = "text"; h.name = "website"; h.tabIndex = -1; h.autocomplete = "off"; h.setAttribute("aria-hidden", "true");
    h.style.cssText = "position:absolute;left:-9999px;width:1px;height:1px;opacity:0"; f.appendChild(h);
  });
  function rvShopSubscribe(f, email, fn, mv) {
    var ctl = window.AbortController ? new AbortController() : null, timer = setTimeout(function () { if (ctl) ctl.abort(); }, 20000);
    return fetch(RV_NL_URL, {
      method: "POST", headers: { "Content-Type": "application/json" }, signal: ctl ? ctl.signal : undefined,
      body: JSON.stringify({ email: email, first_name: fn, lang: RV.lang || "fr", country: RV.country || "", mail: mv, source: f.getAttribute("data-source") || "popup",
        page: location.href.split("#")[0], t: Math.round(window.performance ? performance.now() : 9999), website: ((f.querySelector("input[name=website]") || {}).value || "") })
    }).then(function (r) { clearTimeout(timer); return r.json().then(function (j) { return !!(r.ok && j && j.ok); }, function () { return false; }); },
      function () { clearTimeout(timer); return false; });
  }
  /* Mail language for the Shopify customer tag mail-<variant> (generated by scripts/shopify-email/routing_js.py) */
  function rvMailVariant(c, l, r) {
    /* Brunelia mail language (same rule as scripts/klaviyo/i18n/routing.py): country first, browser language as tie-break
       in CH LU BE CA, browser language when the country is unknown, English otherwise. */
    var M = {"fr":"BL FR GF GP MF MQ NC PF PM RE TF WF YT","fr-eu":"BE MC","fr-world":"HT","de":"AT CH DE LI LU","nl":"NL","es":"AD ES","it":"IT SM VA","pt":"PT","pl":"PL","da":"DK FO","sv":"AX SE","nb":"NO SJ","fi":"FI","cs":"CZ","el":"CY GR","ro":"MD RO","hu":"HU","sk":"SK","hr":"HR","sl":"SI","bg":"BG","lt":"LT","lv":"LV","et":"EE","is":"IS","sr":"BA ME RS","sq":"AL XK","mk":"MK","uk":"UA","en-eu":"GG GI IE JE MT","tr":"TR","pt-br":"BR","es-419":"AR BO CL CO CR DO EC GT HN MX NI PA PE PR PY SV UY VE","en-world":"CA"}, O = {"CH":[["L","^fr([-_].*)?$","fr-eu"],["L","^it([-_].*)?$","it"]],"LU":[["L","^fr([-_].*)?$","fr-eu"],["L","^it([-_].*)?$","it"]],"BE":[["L","^nl([-_].*)?$","nl"]],"CA":[["R","^(Quebec|Qu\u00e9bec|QC|Qc)$","fr-world"],["L","^fr([-_].*)?$","fr-world"]]}, L = [["fr","^fr([-_].*)?$"],["pt-br","^pt[-_][bB][rR]"],["es-419","^es[-_]([0-9A-DF-Za-df-z]|[eE][cC])"],["de","^de([-_].*)?$"],["nl","^nl([-_].*)?$"],["es","^es([-_].*)?$"],["it","^it([-_].*)?$"],["pt","^pt([-_].*)?$"],["pl","^pl([-_].*)?$"],["da","^da([-_].*)?$"],["sv","^sv([-_].*)?$"],["nb","^(nb|no|nn)([-_].*)?$"],["fi","^fi([-_].*)?$"],["cs","^cs([-_].*)?$"],["el","^el([-_].*)?$"],["ro","^ro([-_].*)?$"],["hu","^hu([-_].*)?$"],["sk","^sk([-_].*)?$"],["hr","^hr([-_].*)?$"],["sl","^sl([-_].*)?$"],["bg","^bg([-_].*)?$"],["lt","^lt([-_].*)?$"],["lv","^lv([-_].*)?$"],["et","^et([-_].*)?$"],["is","^is([-_].*)?$"],["sr","^(sr|bs)([-_].*)?$"],["sq","^sq([-_].*)?$"],["mk","^mk([-_].*)?$"],["uk","^uk([-_].*)?$"],["tr","^tr([-_].*)?$"]], k, i;
    if (c) {
      c = String(c).toUpperCase();
      var ov = O[c] || [];
      for (i = 0; i < ov.length; i++) { var val = ov[i][0] === "L" ? l : r; if (val && new RegExp(ov[i][1]).test(val)) return ov[i][2]; }
      for (k in M) if ((" " + M[k] + " ").indexOf(" " + c + " ") > -1) return k;
      return "en-world";
    }
    if (!l) return "fr";
    for (i = 0; i < L.length; i++) if (new RegExp(L[i][1]).test(l)) return L[i][0];
    return "en-world";
  }
  document.addEventListener("submit", function (e) {
    var f = e.target.closest("form[data-rv-newsletter]"); if (!f) return;
    e.preventDefault();
    var email = (f.querySelector("input[type=email]") || {}).value || "", fn = ((f.querySelector("input[name=first_name]") || {}).value || "").trim(), msg = f.querySelector("[data-rv-nl-msg]"), btn = f.querySelector("[type=submit]");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.trim())) { if (msg) msg.textContent = RV.t("core_js.nl_missing"); return; }
    if (btn) btn.disabled = true;
    var bl0 = (navigator.language || "").slice(0, 12), mv = rvMailVariant(RV.country || "", RV.lang || "", bl0);
    var shopP = rvShopSubscribe(f, email.trim(), fn, mv);
    shopP.then(function (ok) { if (!ok) throw new Error("nl"); }).then(function () {
      if (msg) msg.textContent = RV.t("core_js.nl_ok"); f.reset(); f.classList.add("is-done"); store.set("rv-nl", Date.now() + 365 * 864e5);
    })
      .catch(function () { if (msg) msg.textContent = RV.t("core_js.nl_error"); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  /* ---------- « Gérer mes cookies » : préférences de la bannière Shopify ---------- */
  document.addEventListener("click", function (e) {
    var c = e.target.closest("[data-rv-cookies]"); if (!c) return;
    e.preventDefault();
    if (window.privacyBanner && window.privacyBanner.showPreferences) window.privacyBanner.showPreferences();
    else RV.toast(RV.t("core_js.cookies_banner"));
  });

  /* ---------- Rangées qui défilent : flèches ‹ › aux bords + fondu (Romain, 07/10) ----------
     Poser data-rv-scroller sur le conteneur qui défile. Sens détecté (rangée ou colonne).
     Flèches visibles seulement s'il reste du contenu de ce côté ; un toucher fait défiler d'un cran. */
  RV.scroller = function (el) {
    if (el.__rvScr) return; el.__rvScr = 1;
    var mk = function (d) {
      var a = document.createElement("span"); a.className = "rv-scr-a"; a.setAttribute("data-d", d); a.setAttribute("aria-hidden", "true");
      a.innerHTML = "<i></i>"; return a;
    };
    var prev = mk(-1), next = mk(1);
    el.insertBefore(prev, el.firstChild); el.appendChild(next);
    var y = false;
    function bg() {
      for (var n = el; n && n.nodeType === 1; n = n.parentElement) {
        var c = getComputedStyle(n).backgroundColor;
        if (c && c !== "transparent" && !/rgba\(.*,\s*0\)$/.test(c)) return c;
      }
      return "";
    }
    function upd() {
      var cs = getComputedStyle(el);
      y = cs.flexDirection.indexOf("column") === 0;
      el.setAttribute("data-rv-axis", y ? "y" : "x");
      el.style.setProperty("--rv-g", (y ? cs.rowGap : cs.columnGap) === "normal" ? "0px" : (y ? cs.rowGap : cs.columnGap));
      var pos = y ? el.scrollTop : el.scrollLeft, max = y ? el.scrollHeight - el.clientHeight : el.scrollWidth - el.clientWidth;
      prev.classList.toggle("on", pos > 2);
      next.classList.toggle("on", pos < max - 2);
    }
    function paint() { var c = bg(); if (c) el.style.setProperty("--rv-scr-bg", c); upd(); }
    [prev, next].forEach(function (a) {
      a.addEventListener("click", function (e) {
        e.preventDefault(); e.stopPropagation();
        var d = +a.getAttribute("data-d"), step = Math.max(60, (y ? el.clientHeight : el.clientWidth) * 0.7);
        var o = { behavior: reduce ? "auto" : "smooth" }; o[y ? "top" : "left"] = d * step;
        el.scrollBy(o);
      });
    });
    el.addEventListener("scroll", upd, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(paint).observe(el); else window.addEventListener("resize", paint);
    paint();
  };
  $$("[data-rv-scroller]").forEach(RV.scroller);

  /* ---------- Free shipping in the visitor currency (RV.freeConv, set in theme.liquid) ---------- */
  if (RV.freeConv && RV.freeShippingTxt) {
    var shipEsc = function (s) { return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "(?![\\d.,])"; };
    var shipRe = [[new RegExp(shipEsc(RV.freeShippingTxt), "g"), RV.moneyShort(RV.freeConv)]];
    if (RV.shipRateTxt && RV.rateConv) shipRe.push([new RegExp(shipEsc(RV.shipRateTxt), "g"), RV.money(RV.rateConv)]);
    var shipFix = function (root) {
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: function (n) { var p = n.parentNode && n.parentNode.nodeName; return p === "SCRIPT" || p === "STYLE" || p === "TEXTAREA" ? 2 : 1; } }), n;
      while ((n = w.nextNode())) { var v = n.nodeValue, o = v; shipRe.forEach(function (x) { v = v.replace(x[0], x[1]); }); if (v !== o) n.nodeValue = v; }
    };
    shipFix(document.body);
    RV.freeShippingTxt = RV.moneyShort(RV.freeConv);
    new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (a) { if (a.nodeType === 1) shipFix(a); else if (a.nodeType === 3 && a.parentNode) shipFix(a.parentNode); }); }); })
      .observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Ruban : pause du défilement si mouvement réduit ---------- */
  if (reduce) $$(".ribbon-track").forEach(function (t) { t.style.animation = "none"; });
})();

/* Collection filter bar: « is-stuck » only while it sticks under the header, so its mask never covers the page above it.
   Desktop (Romain 20/10): at that point the bar moves to the top of the left column, above « Toutes nos affiches », and the column
   sticks at the same height; it comes back above the grid when scrolling up. The bar is looked up each time because filtering swaps it. */
(function () {
  var main = document.querySelector(".rv-l1 .rv-coll-main");
  var bar = function () { return main && main.parentNode.querySelector("[data-rv-filters]"); };
  var f = bar();
  if (!f || f.parentNode !== main || !("IntersectionObserver" in window)) return;
  var layout = main.parentNode, aside = layout.querySelector(".rv-aside");
  var wide = window.matchMedia("(min-width: 961px)");
  var s = document.createElement("div");
  s.setAttribute("aria-hidden", "true");
  s.style.cssText = "height:1px;margin-bottom:-1px;pointer-events:none";
  main.insertBefore(s, f);
  var hold = document.createElement("div");
  hold.setAttribute("aria-hidden", "true");
  var top = parseFloat(getComputedStyle(f).top) || 0, past = false;
  var place = function () {
    var b = bar(); if (!b) return;
    var side = past && wide.matches && !!aside && aside.parentNode === layout;
    var focus = b.contains(document.activeElement) ? document.activeElement : null;
    if (side && b.parentNode === main) {
      hold.style.height = b.offsetHeight + (parseFloat(getComputedStyle(b).marginBottom) || 0) + "px";
      main.insertBefore(hold, b);
      aside.insertBefore(b, aside.firstChild);
      aside.scrollTop = 0;
    } else if (!side && b.parentNode === aside) {
      main.insertBefore(b, hold.parentNode === main ? hold : s.nextSibling);
      if (hold.parentNode) hold.parentNode.removeChild(hold);
    }
    if (focus && document.activeElement !== focus) focus.focus({ preventScroll: true });
    layout.classList.toggle("is-fcol", b.parentNode === aside);
    b.classList.toggle("is-stuck", past && b.parentNode === main);
  };
  new IntersectionObserver(function (e) { past = !e[0].isIntersecting && e[0].boundingClientRect.top < top + 1; place(); },
    { rootMargin: (-Math.round(top) - 1) + "px 0px 0px 0px" }).observe(s);
  if (wide.addEventListener) wide.addEventListener("change", place);
  /* filtering from the column: show the first results, right under the header (the bar stays in the column) */
  var toResults = function () {
    if (!hold.parentNode) return;
    var y = window.scrollY + hold.getBoundingClientRect().bottom - top;
    if (y < window.scrollY) window.scrollTo({ top: y, behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
  };
  if (aside) {
    aside.addEventListener("click", function (e) { if (e.target.closest("[data-rv-filters] a[data-rv-f]")) toResults(); });
    aside.addEventListener("change", function (e) { if (e.target.closest("[data-rv-filters] [data-rv-sort]")) toResults(); });
  }
})();
